import React from "react"

export default [
  {
    year: 2021,
    description: (
      <ul>
        <li>Deployed Qoqolo Pre-school management system for Invictus International Programme</li>
        <li>Obtained initial Certification for ISO 9001:2015 (QMS). <br/>Date: 6 August 2021 (Cert No: 701451)</li>
        <li>Obtained certification for SS620 : 2016 (GDPMDS) again. <br/>Date: 18 Oct 2021 (Cert No: 768321)</li>
      </ul>
    )
  },
  {
    year: 2020,
    description: (
      <ul>
        <li>Designed UX for MOE Talents System</li>
        <li>Awarded and launched international event sites: Singapore Airshow, IMDEX Asia, Rotorcraft Asia and Unmanned Systems Asia.</li>
        <li>Deployed Qoqolo Pre-school management system for White Lodge Education Group Services Pte Ltd </li>
        <li>Awarded and developed website for Continuing Education Training (CET) Academy, Ngee Ann Polytechnic</li>
        <li>Awarded and developed website for World Cities Summit 2021</li>
        <li>Awarded and developed website for Singapore International Water Week 2021</li>
        <li>Launched PesonaEdu A-Class Learning Management System in Indonesia</li>
      </ul>
    )
  }
  , {
    year: 2019,
    description: (
      <ul>
        <li>Qoqolo for Star Learners Preschools</li>
        <li>Dudu Home version launched</li>
        <li>Vatitude e-Textbook for 30 Indonesian publishers</li>
      </ul>
    ),
  },
  {
    year: 2018,
    description: (
      <ul>
        <li>Launched User Experience Design (UXD) Service for Government Agencies</li>
        <li>R&amp;D Partnership with A*Star I2R in AI speech technologies</li>
        <li>Launched ChineseGo learning app - with NIE and St. Anthony's Canossian Secondary School</li>
        <li>Obtained SS 620 : 2016 GDPMDS Certification</li>
      </ul>
    ),
  },
  {
    year: 2017,
    description: (
      <ul>
        <li>Launched Dudu iPad App on AppStore</li>
        <li>
          Awarded for the Community Based Care IT System jointly developed with
          St Luke's ElderCare
        </li>
        <li>
          Appointed to be a qualified provider of SMART Solutions for
          pre-schools, Qoqolo School Management System
        </li>
      </ul>
    ),
  },

  {
    year: 2016,
    description: (
      <ul>
        <li>
          Awarded Web Contractor for IDA(T)1374 Content Websites Platform tender
        </li>
        <li>
          Swiiit appointed as selected content management system for IDA(T)1374
          Content Websites Platform tender
        </li>
        <li>
          Swiiit selected by 274 schools in Singapore as the content management
          system
        </li>
        <li>
          Awarded Integrated Portal for Mother Tongue Languages (iMTL2) tender
        </li>
      </ul>
    ),
  },

  {
    year: 2015,
    description: (
      <ul>
        <li>
          Launched Dudu Personalised Chinese Learning System to Singapore
          schools
        </li>
        <li>Distinguished Paper at 4th Int'l Conf. on the Teaching and Learning of Chinese as a Second Language</li>
        <li>
          Qoqolo School Management System rolled out to all NTUC First Campus'
          My First Skool and Little Skool-House Centres.
        </li>
      </ul>
    ),
  },

  {
    year: 2014,
    description: (
      <ul>
        <li>
          Awarded Civil Service College ULMS (Unified Learning Management
          System) tender to provide a unified elearning portal to the 70,000
          civil servants attending CSC courses.
        </li>
      </ul>
    ),
  },

  {
    year: 2013,
    description: (
      <ul>
        <li>
          Appointed IDA Saas vendor for pre-schools - Qoqolo School Management
          System and e-Portfolio.{" "}
        </li>
        <li>
          MOE OPAL, powered by CommonAcademy, is the software developer that won
          the Asia Pacific FutureGov Award - Education Organisation of the Year.
        </li>
      </ul>
    ),
  },

  {
    year: 2012,
    description: (
      <ul>
        <li>Awarded MOE OPAL LCMS tender</li>
      </ul>
    ),
  },

  {
    year: 2011,
    description: (
      <ul>
        <li>Awarded MOE East Zone Repository.</li>
        <li>Awarded MOE IK21 CFC - pre-school e-Portfolio System.</li>
        <li>
          Awarded MDA Futurescape Grants under a CommonTown-Pearson partnership
          to research and develop an Online Chinese Accelerated Reading
          Programme
        </li>
      </ul>
    ),
  },

  {
    year: 2009,
    description: (
      <ul>
        <li>
          Singapore MOE and CommonTown became joint winner of the IMS Learning
          Impact Award (Silver) and bagged the Best Repository Solution
        </li>
      </ul>
    ),
  },

  {
    year: 2008,
    description: (
      <ul>
        <li>Awarded MOE Edumall2.0 tender, rolled out to all MOE teachers.</li>
      </ul>
    ),
  },

  {
    year: 2007,
    description: (
      <ul>
        <li>
          Implemented S-Link teachers repository for South Clusters schools.
        </li>
        <li>
          Appointed as the Vendor for School Websites Bulk Tender (Swiiit V2).
        </li>
      </ul>
    ),
  },

  {
    year: 2006,
    description: (
      <ul>
        <li>
          Implemented WeSHARE teachers repository for West Cluster of schools
        </li>
        <li>Launched V1 Swiiit DIY web-builder</li>
        <li>Appointed by A*Star to productize Text-mining SDK</li>
      </ul>
    ),
  },

  {
    year: 2005,
    description: (
      <ul>
        <li>Completed MOE iSHARE proof-of-concept project for MOE.</li>
        <li>
          Launched 12wap Mobile Community with Clearhub for MY 8TV/TV3 viewers.
        </li>
      </ul>
    ),
  },

  {
    year: 2004,
    description: (
      <ul>
        <li>
          Awarded MOE/IDA Prowess CFC &ndash; trial led Project Work System in
          schools
        </li>
      </ul>
    ),
  },

  {
    year: 2003,
    description: (
      <ul>
        <li>E-learning partnerships established in HK and China.</li>
      </ul>
    ),
  },

  {
    year: 2001,
    description: (
      <ul>
        <li>
          Introduced web content management products and solutions. E-Learning
          partnership with major publishers.
        </li>
      </ul>
    ),
  },

  {
    year: 1999,
    description: (
      <ul>
        <li>Spin-off from A*STAR.</li>
        <li>
          Establishment and introduced E-community services for the education
          industry.
        </li>
      </ul>
    ),
  },
]
